import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-request-intro-step',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col items-center justify-center h-full py-12">
      <h2 class="text-2xl font-medium mb-8">Wat wilt u doen?</h2>
      <div class="grid grid-cols-2 gap-6 w-full max-w-2xl">
        <button
          type="button"
          (click)="selectType('request')"
          [class.border-primary-500]="selectedType === 'request'"
          [class.ring-2]="selectedType === 'request'"
          [class.ring-primary-200]="selectedType === 'request'"
          [class.bg-primary-50]="selectedType === 'request'"
          class="flex flex-col items-center justify-center p-6 border rounded-lg hover:border-primary-500 hover:bg-primary-50 transition-colors"
        >
          <span class="text-lg font-medium">Nieuwe aanvraag</span>
          <span class="text-sm text-gray-500 mt-2 text-center">
            Vraag een nieuwe lift plaatsing aan
          </span>
        </button>

        <button
          type="button"
          (click)="selectType('withdrawal')"
          [class.border-primary-500]="selectedType === 'withdrawal'"
          [class.ring-2]="selectedType === 'withdrawal'"
          [class.ring-primary-200]="selectedType === 'withdrawal'"
          [class.bg-primary-50]="selectedType === 'withdrawal'"
          class="flex flex-col items-center justify-center p-6 border rounded-lg hover:border-primary-500 hover:bg-primary-50 transition-colors"
        >
          <span class="text-lg font-medium">Terugname aanvraag</span>
          <span class="text-sm text-gray-500 mt-2 text-center">
            Vraag een terugname aan voor een lift plaatsing
          </span>
        </button>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestIntroStepComponent {
  @Input() selectedType: 'request' | 'withdrawal' | null = null;
  @Output() typeSelected = new EventEmitter<'request' | 'withdrawal'>();

  selectType(type: 'request' | 'withdrawal') {
    this.typeSelected.emit(type);
  }
}
